<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import './components/common/common';

  export default {
    mounted() {
      this.resize(375);
    }
  };
</script>

<style lang="scss" scoped>
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?6453fb81